import { useState } from "react";
import { useApiGet } from "../../utils/api";
import { useModal } from "../../utils/modal_launcher";
import { TripModal } from "./trip_modal";
import { formatDate } from "../../utils/helpers";

export const UserHome = () => {
  const [activeTab, setActiveTab] = useState<"upcoming" | "past">("upcoming");
  const { data, unavailable } = useApiGet(
    { home: "/api/user/home" },
    { filter: activeTab }
  );
  const tripModal = useModal(TripModal, {});

  if (unavailable) {
    return unavailable;
  }
  console.log(data, unavailable);

  const trips = data?.trips || [];

  return (
    <div className="container py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>My Trips</h2>
        <button className="btn btn-primary" onClick={() => tripModal.show({})}>
          + New Trip
        </button>
      </div>
      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <button
            className={`nav-link${activeTab === "upcoming" ? " active" : ""}`}
            onClick={() => setActiveTab("upcoming")}
            type="button"
          >
            Upcoming
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link${activeTab === "past" ? " active" : ""}`}
            onClick={() => setActiveTab("past")}
            type="button"
          >
            Past
          </button>
        </li>
      </ul>

      {trips.length === 0 && (
        <div className="text-muted py-4 text-center">No trips to show.</div>
      )}
      {trips.length > 0 && (
        <div className="">
          {trips.map((trip: any) => (
            <div key={trip.id} className="item my-4">
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <a href={`/user/trip/${trip.id}`} className="fs-24 mb-1">
                    {trip.name}
                  </a>
                  <div className="mt-1">
                    {formatDate(trip.from)} - {formatDate(trip.to)}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
